var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18C36 27.9395 27.9395 36 18 36C8.05718 36 0 27.9395 0 18C0 18.0033 18 0.00331981 18 0C27.9395 0 36 8.0605 36 18Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9502 18H18C18 17.9834 18 17.9668 18 17.9502C17.9834 17.9668 17.9668 17.9834 17.9502 18Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.3911C18 6.22401 18 4.14913 18 0.00268555H17.9967C8.05718 0.00268555 0 8.05986 0 17.9994H9.39174V12.7109L14.6802 17.9994H17.9502C17.9668 17.9861 17.9834 17.9695 18 17.9529C18 16.7412 18 15.6589 18 14.6796L12.7115 9.3911H18Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10617 2.34717C6.29098 3.95064 3.95051 6.2911 2.34705 9.1063V18.0001H7.04457V7.0447H17.9999C17.9999 5.56074 17.9999 4.14982 17.9999 2.34717H9.10617Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.7858L11.606 9.39185H9.39172L18 18.0001C18 18.0001 18 16.473 18 15.7858Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8558 21.1306L11.8451 23.1955L14.0727 22.681L13.0768 24.7392L14.8695 26.1634L12.6352 26.6681L12.6419 28.9554L10.8559 27.5246L9.0698 28.9554L9.07644 26.6681L6.84216 26.1634L8.63486 24.7392L7.6356 22.681L9.86651 23.1955L10.8558 21.1306Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9502 25.0447L27.4415 26.0771L28.557 25.8182L28.059 26.8473L28.9554 27.5611L27.8399 27.8101L27.8433 28.9554L26.9502 28.2383L26.0572 28.9554L26.0605 27.8101L24.9418 27.5611L25.8381 26.8473L25.3401 25.8182L26.4556 26.0771L26.9502 25.0447Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3556 14.0859L22.847 15.1184L23.9624 14.8628L23.4644 15.8919L24.3608 16.6023L23.2453 16.8547L23.2487 18L22.3557 17.2829L21.4626 18V16.8547L20.3472 16.6023L21.2435 15.8919L20.7455 14.8628L21.861 15.1184L22.3556 14.0859Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9502 7.82812L27.4415 8.86059L28.557 8.60164L28.059 9.63078L28.9554 10.3445L27.8399 10.5935L27.8433 11.7389L26.9502 11.0218L26.0572 11.7389L26.0605 10.5935L24.9418 10.3445L25.8381 9.63078L25.3401 8.60164L26.4556 8.86059L26.9502 7.82812Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9639 12.5222L31.4552 13.5547L32.5707 13.2957L32.0727 14.3282L32.9691 15.0386L31.8536 15.2909L31.857 16.4363L30.9639 15.7192L30.0709 16.4363V15.2909L28.9554 15.0386L29.8518 14.3282L29.3538 13.2957L30.4693 13.5547L30.9639 12.5222Z",
    fill: "#F0F0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0922 18L28.4806 19.1951H29.7388L28.7196 19.9354L29.108 21.1306L28.0922 20.3903L27.0763 21.1306L27.4647 19.9354L26.4456 19.1951H27.7038L28.0922 18Z",
    fill: "#F0F0F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAud);
export default __webpack_public_path__ + "static/media/AUD.4c26e901f14bbb4670c616e9f091fad3.svg";
export { ForwardRef as ReactComponent };